import React, {useState, useContext} from 'react';
import {NavDropdown} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons";
import  {Badge} from 'react-bootstrap';
import { UserContext } from '../partials/Context';
import getCookie from '../partials/cookie';
import { useEffect } from 'react';

function NavbarRight(props) {
        const [links_converted, setLinks] = useState([]);
        const user = useContext(UserContext);
        const {is_authenticated, impersonated} = user || '';
        const {right_links, dropdown_menu_links, messages, lawyer_img} = props;
        let list = [];
        const {links} = right_links || [];

        const {links: dropdown_menu} = dropdown_menu_links || [];

        let temporary_links = [];
        const csrftoken = getCookie('csrftoken');

        if (links) {
            if(!impersonated) {
                temporary_links[0] = {};
                links.forEach((item) => {
                    temporary_links.push(item)
                })
            } else {
                links.forEach((item) => {
                    temporary_links.push(item);
                })
            }
        }

        useEffect(() => {
            setLinks(temporary_links);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [links])

        if (dropdown_menu)
        dropdown_menu.map((item, index)=>{
            item = dropdown_menu[index];
            const {href, text} = item || '';
            // eslint-disable-next-line no-mixed-operators
            if (text !== 'Wyloguj' && (index !== 4 && is_authenticated || index !== 3 && !is_authenticated)) {
                list.push(
                    <NavDropdown.Item key={index} href={href}>{text}</NavDropdown.Item>
                )
            } else if (text === 'Wyloguj') {
                console.log(item)
                list.push(
                    <form id="logout-form" method="post" action={href} key={index}>
                        <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken} />
                        <button type="submit"><i class="fa fa-share"></i> Wyloguj</button>
                    </form>)
            } else {
                list.push(
                <NavDropdown.Item key={index} href={href}>{text}
                <Badge className="badge success ml-8">NOWE</Badge>
                </NavDropdown.Item>
                )
            }
            return list
        })
        const [administracja, zadzwon, wiadomosci] = links_converted || [];
        
        const {href: zadzwon_href, text: zadzwon_text, tel} = zadzwon || '';
        const {href: wiadomosci_href, text: wiadomosci_text} = wiadomosci || '';
    
        if (is_authenticated === true) {
        if (lawyer_img) {
            return (
                <ul className="nav navbar-nav navbar-right logged-in">
                    <li>
                        <span className={`powiadomienia ${impersonated ? 'impersonated' : ''}`}>
                            <PowrótDoAdministracji links={administracja}/> 
                            <a href={wiadomosci_href}>
                                <FontAwesomeIcon icon={faEnvelope}className="fa-2x envelope"></FontAwesomeIcon>
                            </a>
                            <a className={`zadzwon ${impersonated? 'zadzwon_impersonated': ''}`}href={zadzwon_href}>
                                {zadzwon_text} {tel}
                            </a>
                            <a className='wiadomosci'href={wiadomosci_href}>{wiadomosci_text}</a>
                            <span className="badge badge-success circle" >{messages}</span>
            </span>
                    </li>
                    <li className="dropdown my_dropdown" >
                        <img src={lawyer_img} className='profile-photo' alt="zdjęcie profilowe prawnika"/>
                        <NavDropdown title="Profil prawnika" id="" className="prawnik_start">
                            {list}
                        </NavDropdown>
                    </li>
                </ul>
            ) 
         }}  else if (is_authenticated === false) {
        return (
            <ul className="nav navbar-nav navbar-right logged-out">
                <PowrótDoAdministracji links={administracja}/> 
                <li className="phone-call">
                    <Badge className="phone-button">
                        <a href={zadzwon_href}>
                        <img className="phone-icon" src="/media/img/phone-button.png?be2d3d93d041" alt="" />
                        {zadzwon_text}
                        </a>
                    </Badge>
                </li>
                <li className="login">
                    <a  href={wiadomosci_href}>
                        {wiadomosci_text}
                    </a>
                    </li>
                    <li className="dropdown my_dropdown" >
                        <NavDropdown title="STREFA PRAWNIKA" id="" className="prawnik_start logout">
                            {list}
                        </NavDropdown>
                    </li>
                </ul>
        )
    }
    }

class PowrótDoAdministracji extends React.Component {
    render() {
        const {links} = this.props
        const {href: admin_href, text: admin_text} = links || '';
        if(admin_href) {
            return (
                <a className='powrot_do_administracji'href={admin_href}>{admin_text}</a>
            )
        }
    }
}


export default NavbarRight;